export interface IExchangeAPI {
  exchange_id: number;
  name: string;
  created_on_utc: string;
  modified_on_utc: string;
  is_white_labeled: boolean;
}

export default class Exchange {
  id: number;

  name: string;

  createdOnUtc: string;

  modifiedOnUtc: string;

  className: string;

  isWhiteLabeled: boolean;

  constructor(id: number, name: string, createdOnUtc: string, modifiedOnUtc: string, isWhiteLabeled = false) {
    this.id = id;
    this.name = name;
    this.createdOnUtc = createdOnUtc;
    this.modifiedOnUtc = modifiedOnUtc;
    this.className = 'exchange';
    this.isWhiteLabeled = isWhiteLabeled;
  }

  static fromApi(apiObject: IExchangeAPI): Exchange {
    return new Exchange(
      apiObject.exchange_id,
      apiObject.name,
      apiObject.created_on_utc,
      apiObject.modified_on_utc,
      apiObject.is_white_labeled,
    );
  }

  get isDemandOrganization(): boolean {
    return false;
  }

  get isSupplyOrganization(): boolean {
    return false;
  }

  get isCuratorOrganization(): boolean {
    return false;
  }

  get isExchange(): boolean {
    return true;
  }

  toApi(): IExchangeAPI {
    return {
      exchange_id: this.id >= 0 ? this.id : undefined,
      name: this.name,
      created_on_utc: this.createdOnUtc,
      modified_on_utc: this.modifiedOnUtc,
      is_white_labeled: this.isWhiteLabeled,
    };
  }
}
